// extracted by mini-css-extract-plugin
module.exports = {"progress_dots":"ProgressDots_progress_dots__1IAEE","progress_bar":"ProgressDots_progress_bar__iG4Wh","loader":"ProgressDots_loader__7VaQn","dots":"ProgressDots_dots___q_tV"};